import React from 'react';
import { useAppSelector } from '../../hooks/storeHooks';

const StreamingMonitor: React.FC = () => {
    const cardDateStore = useAppSelector((state) => state.rodLiftAnalysis);


    if (cardDateStore.streamingComplete ||
        (cardDateStore.values.length > 0 && !cardDateStore.isLoading && !cardDateStore.isStreaming)) {
        return null;
    }

    return (
        <div className="fixed top-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
            <h3 className="font-bold text-sm mb-2">Status Monitor</h3>
            <div className="text-xs space-y-1">
                <div>Cards: <span className="font-mono">{cardDateStore.values.length}</span></div>
                <div className="flex space-x-2">
                    <span className={`w-2 h-2 rounded-full ${cardDateStore.isStreaming ? 'bg-blue-400' : 'bg-gray-600'}`}></span>
                    <span>Streaming</span>
                </div>
            </div>
        </div>
    );
};

export default StreamingMonitor;
